import { useEffect, useState } from "react";
import api from "@/lib/api";
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import AccreditationCards from "@/components/RightMateSection";

export default function AccreditationPage() {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    document.title = "Accreditation — Bulls of the Big Sky";
    api.get("/site-settings").then((r) => setSettings(r.data));
  }, []);

  return (
    <div data-testid="accreditation-page" className="min-h-screen" style={{ background: "var(--bg-primary)" }}>
      <SiteHeader />

      {/* HERO */}
      <section className="pt-40 pb-12 px-6 md:px-12">
        <div className="max-w-[1400px] mx-auto">
          <div className="eyebrow">RightMate  •  Powered by Top Genomics</div>
          <h1 className="font-display text-5xl md:text-7xl lg:text-8xl mt-4 leading-[0.98]">
            Improved buying confidence with<br />greater genomic assurance.
          </h1>
        </div>
      </section>

      {/* INTRO + CARDS */}
      <section data-testid="rightchoice-section" className="pb-24 md:pb-28 px-6 md:px-12">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-start">
            <div className="md:col-span-7">
              <p className="text-base md:text-lg leading-relaxed" style={{ color: "var(--text-primary)" }}>
                Access to more and better information has always been key to making wise decisions. The
                evolution and improvement of genetic evaluation tools too has given us an ever-clearer
                picture of the true genetic makeup of cattle and thus a better view of the value
                proposition. RightMate, powered by Top Genomics LLC is taking the evaluation of genetics
                and genomics one giant step further. By combining specific genomic information with the
                long-proven value of EPDs, this new advancement in technology improves our depth and
                precision when evaluating the actual ability to transmit value and profit.
              </p>
            </div>
            <div className="md:col-span-5">
              <p className="text-base md:text-lg leading-relaxed" style={{ color: "var(--text-secondary)" }}>
                The 3 Accreditation Logos below are designed to simplify bull selection and improve buyer
                confidence by more accurately describing the genetics offered and by reducing risk. What
                this means to you as a customer is a much greater assurance that you are getting both what
                you want and need from the genetics you purchase. What it means to your seedstock provider
                is access to RightMate technology that simply sets them apart from the rest of the
                industry.
              </p>
            </div>
          </div>

          <AccreditationCards />

          <p className="mt-12 eyebrow text-[11px]">
            Marty Ropp{" "}
            <a href="tel:406-581-7835" className="link-brass">406-581-7835</a>
            {"  •  "}RightMate — powered by Top Genomics
          </p>
        </div>
      </section>

      <SiteFooter settings={settings} />
    </div>
  );
}
